// React Context를 사용하는 common.js
import { useComtrue } from './ocr_variables'
import { useNavigate } from 'react-router-dom'
import { showAlert } from 'app/shared/utils/util'

// 디버그 로그 - Context를 받아서 사용
export const debugLog = (msg, debugMode) => {
    if (debugMode) {
        console.log(msg)
    }
}

// 창 닫기 - navigate와 cleanup 함수를 받아서 사용
export const closeThis = (msg, navigate, stopCameraStream) => {
    console.log(`[COMTRUECommon.closeThis] START: ${msg}`)

    setTimeout(() => {
        stopCameraStream?.()
    }, 333)

    if (msg?.length > 4) {
        showAlert({
            msg: msg,
            onConfirm: () => {
                // 새로고침 시 데이터 유지를 위함.
                sessionStorage.setItem('hasStarted', 'false')

                window.localStorage.removeItem('pubKey')
                window.localStorage.removeItem('priKey')
                window.localStorage.removeItem('comtrue_callback')

                document.cookie =
                    'ComtrueSession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

                window.open('about:blank', '_self')?.close()
            },
        })
        return
    } else {
        // 새로고침 시 데이터 유지를 위함.
        sessionStorage.setItem('hasStarted', 'false')

        window.localStorage.removeItem('pubKey')
        window.localStorage.removeItem('priKey')
        window.localStorage.removeItem('comtrue_callback')

        document.cookie =
            'ComtrueSession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

        window.open('about:blank', '_self')?.close()
    }
}

// PostMessage 전송
export const settingAndSendPostMessages = (data) => {
    const targets = [
        () => window.opener?.postMessage(data, '*'),
        () => window.parent?.postMessage(data, '*'),
        () => window.ReactNativeWebView?.postMessage(JSON.stringify(data)),
        () => window.Android?.postMessage(JSON.stringify(data)),
        () =>
            window.webkit?.messageHandlers?.iosWebView?.postMessage(
                JSON.stringify(data)
            ),
    ]
    targets.forEach((send) => {
        try {
            send()
        } catch (e) {
            console.error('PostMessage error:', e)
        }
    })
}

// OCR 콜백 결과 설정
export const settingOcrCallbackResultVars = (data) => {
    try {
        if (typeof window.ocrCallbackResult !== 'undefined') {
            window.ocrCallbackResult = data.childData
        }
        if (typeof window.ocrCallbackResultStatus !== 'undefined') {
            window.ocrCallbackResultStatus = data.status
        }
    } catch (e) {
        console.error('Setting OCR callback error:', e)
    }
}

// PostMessage 헬퍼 함수들
export const sendPostMessageResult = (param) => {
    const data = { childData: 'comtrue_result', status: 0, ocrData: param }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageClose = () => {
    const data = { childData: 'comtrue_close', status: -1 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageTimeout = () => {
    const data = { childData: 'comtrue_timeout', status: -2 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageTokenNotExist = () => {
    const data = { childData: 'comtrue_token_not_exist', status: -3 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageOcrFail = () => {
    const data = { childData: 'comtrue_ocr_fail', status: -4 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageCameraAccess = () => {
    const data = { childData: 'comtrue_camera_access', status: -5 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageCameraInit = () => {
    const data = { childData: 'comtrue_camera_init', status: -6 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageFakeOcr = () => {
    const data = { childData: 'comtrue_fake_ocr', status: -7 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

export const sendPostMessageFakeFace = () => {
    const data = { childData: 'comtrue_fake_face', status: -8 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

// [25.07.02] 최대 촬영 도달시 close 추가
export const sendPostMessageMaxCount = () => {
    const data = { childData: 'comtrue_captrue_max_count', status: -10 }
    settingAndSendPostMessages(data)
    settingOcrCallbackResultVars(data)
}

// 누락 추가
export const pageReload = () => {
    window.location.reload()
}

// Context와 함께 사용하는 submitEkyc
export const submitEkyc = async (
    ekycMode,
    token,
    contextPath,
    navigate,
    debugMode,
    stopCameraStream
) => {
    if (debugMode) console.log('[submitEkyc] START: ' + ekycMode)

    if (ekycMode !== undefined && ekycMode) {
        try {
            const response = await fetch(`${contextPath}/uploadSession`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: '*/*',
                },
                body: `token=${encodeURIComponent(token)}`,
            })

            if (response.ok) {
                window.location.reload()
            } else {
                throw new Error('Session update failed')
            }
        } catch (error) {
            if (debugMode) {
                console.log('session cnt update error:', error)
            }
            sendPostMessageClose()
            closeThis(
                '[!]세션작업 도중 오류가 발생하였습니다.',
                navigate,
                stopCameraStream
            )
        }
    } else {
        sendPostMessageResult()
        closeThis(null, navigate, stopCameraStream)
    }
}

// Context와 함께 사용하는 CallResult
export const CallResult = async ({
    contextPath,
    token,
    onSuccess,
    onError,
    debugMode,
}) => {
    if (debugMode) console.log('[CallResult] START')

    const formData = new FormData()
    formData.append('token', token)
    formData.append('returnFile', 'false')
    formData.append('returnFace', 'false')
    formData.append('returnFaceCrop', 'false')
    formData.append('returnIdcard', 'false')
    formData.append('returnIdcardCrop', 'false')
    formData.append('returnFaceIdcard', 'false')

    try {
        const response = await fetch(`${contextPath}/api/v3/ekyc/result`, {
            method: 'POST',
            body: formData,
        })

        const data = await response.json()

        if (data.status === 0) {
            onSuccess?.({
                iconSrc: `${contextPath}/static/img/icon/complete_blue.png`,
                comment: '본인확인 자료가 제출되었습니다.',
                status: 'success',
                data,
            })
        } else {
            onError?.({
                iconSrc: `${contextPath}/static/img/icon/error_blue.png`,
                comment: '인증 실패',
                status: 'error',
                data,
            })
        }
    } catch (error) {
        onError?.({
            comment: '일치여부 조회 실패',
            status: 'network_error',
            error,
        })
    }
}

// Context와 함께 사용하는 DrawPhoto
export const DrawPhoto = ({ faceImage, idcardFaceImage, debugMode }) => {
    if (debugMode) console.log('[DrawPhoto] START')

    return {
        leftImage: faceImage,
        rightImage: idcardFaceImage,
        showImages: true,
        showDingDing: false,
    }
}

// setReturnFileOrFaceDefault with context
export const setReturnFileOrFaceDefault = (cardType, ekycMode) => {
    let returnFile = 'true'
    if (cardType === 'account' || cardType === 'imei') {
        returnFile = 'false'
    }

    let returnFace = 'true'
    if (ekycMode) {
        returnFace = 'true'
    } else {
        const faceRequiredTypes = [
            'jumin',
            'driver',
            'alien',
            'kpassport',
            'passport',
            'general',
        ]
        returnFace = faceRequiredTypes.includes(cardType) ? 'true' : 'false'
    }

    return { returnFile, returnFace }
}

// 디바이스 체크 함수들 (Context 불필요)
export const isMobileDevice = () => {
    return navigator.userAgent.match(
        /Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/
    )
}

export const isTabletDevice = () => {
    const isTabletOrPc = !navigator.userAgent.match(
        /Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/
    )
    return isTabletOrPc && isMobileDevice()
}

// React Hook으로 사용할 수 있는 유틸리티
export const useComtrueUtils = () => {
    const comtrue = useComtrue()
    const navigate = useNavigate()

    const utils = {
        debugLog: (msg) => debugLog(msg, comtrue.debugModeComtrue),

        closeThis: (msg) =>
            closeThis(msg, navigate, () => {
                // 카메라 스트림 정리 로직
                window.ComtrueCamera?.stopCameraStream?.()
            }),

        submitEkyc: async (ekycMode) =>
            submitEkyc(
                ekycMode,
                comtrue.tokenComtrue,
                comtrue.contextPathComtrue,
                navigate,
                comtrue.debugModeComtrue,
                () => window.ComtrueCamera?.stopCameraStream?.()
            ),

        callResult: async (onSuccess, onError) =>
            CallResult({
                contextPath: comtrue.contextPathComtrue,
                token: comtrue.tokenComtrue,
                onSuccess,
                onError,
                debugMode: comtrue.debugModeComtrue,
            }),

        drawPhoto: (faceImage, idcardFaceImage) =>
            DrawPhoto({
                faceImage,
                idcardFaceImage,
                debugMode: comtrue.debugModeComtrue,
            }),

        setReturnFileOrFaceDefault: (cardType) =>
            setReturnFileOrFaceDefault(cardType, comtrue.ekycModeComtrue),
    }

    return utils
}
